var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.year.year))]),_c('div',{class:_vm.b('amount')},[_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.amount)))]),_c('div',{class:_vm.b('type')},[_vm._v(_vm._s(_vm.type))])])
}
var staticRenderFns = []

export { render, staticRenderFns }